import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Sets (or clears) the user-visible display name for an image asset.
// Passing an empty / whitespace-only name clears the field entirely, so the
// image picker falls back to its derived label (entity name + level/variation
// from pack membership). Non-empty values are trimmed and stored on the
// image's ImageMetadata.
export class SetImageDisplayNameCommand extends CommandBase {
    imageKey: string;
    displayName: string;

    constructor(imageKey: string, displayName: string) {
        super();
        this.imageKey = imageKey;
        this.displayName = displayName;
    }

    execute(data: RemoteConstantsModel): boolean {
        const existing = data.images?.[this.imageKey];
        if (existing == null) return false;

        const trimmed = (this.displayName ?? '').trim();

        // Legacy data: some older branches store the bare filename as a
        // string instead of an ImageMetadata object. Convert in-place so we
        // can attach the display name. Defaults match AddImageCommand.
        let meta: any;
        if (typeof existing === 'string') {
            if (trimmed.length === 0) return false;     // nothing to set; don't bother converting
            meta = {fileName: existing, pixelMultiplier: 800, offsetX: 0.5, offsetY: 0.5};
            data.images[this.imageKey] = meta;
        } else {
            meta = existing;
        }

        if (trimmed.length === 0) {
            if (meta.displayName === undefined) return false;
            delete meta.displayName;
            return true;
        }
        if (meta.displayName === trimmed) return false;
        meta.displayName = trimmed;
        return true;
    }
}
